module.exports = __webpack_public_path__ + "static/media/Warning.dbcab315.svg";